import Dimens from 'assets/dimens';
import { heroLanding } from 'assets/images';
import { BodyText, DefaultButton, TitleMedium } from 'common/presentation/components';
import {
	Alert,
	Box, CircularProgress, Grid, Stack, Typography, useMediaQuery, useTheme,
} from '@mui/material';
import TextField from 'common/presentation/components/text-field/TextField';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AtField } from 'assets/icons';
import { makeForgotPasswordValidation } from '../builder/authentication-factory';
import useAuth from '../provider/auth.provider';
import useNotificationsContext from 'common/presentation/providers/notifications.provider';
import { Link } from 'react-router-dom';
import AppLinks from 'assets/applinks.routes';

const ForgotPasswordPage = () => {
	const { t } = useTranslation('translations');
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'));
	const [email, setEmail] = useState<string>('');
	const [emailError, setEmailError] = useState<string>('');
	const [success, setSuccess] = useState<string>('');
	const { forgotPassword, loading, error } = useAuth();
	const { toast } = useNotificationsContext();

	const validation = makeForgotPasswordValidation();

	const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		const emailErrorV = validation.validate('email', { email });

		setEmailError(emailErrorV);
		if (!emailErrorV) {
			forgotPassword(email).then((result) => {
				if (result) {
					setEmail('');
					toast.current?.show({
						severity: 'success',
						summary: 'Sucesso',
						detail: result,
					});
					setSuccess(t('forgot_password_success'));
				}
			});
		}
	};

	return (
		<Box sx={{
			backgroundImage: isMd ? `url(${heroLanding})` : 'none',
			backgroundPosition: 'left top',
			backgroundRepeat: 'no-repeat',
			backgroundSize: '50% 100%',
			mt: Dimens.INTRO_HERO_IMAGE_TOP,
		}}
		>
			<Stack
				alignItems="flex-end"
				sx={{
					width: { md: '100%', xs: '100%' },
					pl: { md: Dimens.PAGE_PADDING_SMALL, xs: Dimens.PAGE_PADDING_SMALL_MOBILE },
					pr: Dimens.PAGE_PADDING_SMALL_MOBILE,
					pt: { md: Dimens.INTRO_HERO_IMAGE_TOP_POSITIVE, xs: Dimens.SECTION_SPACING },
				}}
			>
				<Box sx={{ width: { md: '50%', xs: '100%' }, height: '85vh' }}>
					<Stack justifyContent="center" sx={{ height: '100%' }}>
						<TitleMedium>
							{t('forgot_password')}
						</TitleMedium>
						<BodyText sx={{ mt: 2 }}>
							{t('forgot_password_info')}
						</BodyText>
						<Stack mt={5}>
							<Typography color="red">
								{error}
							</Typography>
							{success && (
								<Alert severity="success" sx={{ mb: 2 }}>
									{success}
								</Alert>
							)}
						</Stack>
						<form onSubmit={onSubmit} autoComplete="off">
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<TextField
										name="email"
										placeholder="Email"
										error={!!emailError}
										helperText={emailError}
										onChange={(e) => setEmail(e.target.value)}
										fullWidth
										startIcon={<AtField />}
									/>
								</Grid>
								<Grid item md={7} xs={12} mt={2}>
									<Stack>
										<DefaultButton type="submit" disabled={loading} sx={{ alignSelf: 'center' }}>
											{loading && <CircularProgress size={30} />}
											{!loading && t('enter')}
										</DefaultButton>
									</Stack>
								</Grid>
								<Grid item md={12}>
									<BodyText sx={{ mt: 2 }}>
										<Link style={{ textDecoration: 'none', color: '#B9C92B' }} to={AppLinks.LOGIN}>{t('back_to_login')}</Link>
									</BodyText>
								</Grid>
							</Grid>
						</form>
					</Stack>
				</Box>
			</Stack>
		</Box>
	);
};

export default ForgotPasswordPage;
